import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Button } from 'antd';
import configs from 'configs';
import messages from './messages';

import './styles.scss';
import 'antComponentsStyle';

const ButtonBoard = ({
  onSave,
  canSave,
  onCancel,
  onDelete,
  onClone,
  offerCode,
}) => (
  <div className="car-item-button-board">
    <Button
      type="primary"
      className="mb-3"
      block
      size="large"
      onClick={onSave}
      disabled={!canSave}
    >
      <FormattedMessage {...messages.submit} />
    </Button>
    {configs.cloneCatalogOffer &&
      onClone && (
        <Button className="mb-3 btn-clone" block size="large" onClick={onClone}>
          <FormattedMessage {...messages.clone} />
        </Button>
      )}
    {onDelete && (
      <Button
        className="mb-3"
        block
        size="large"
        onClick={onDelete}
      >
        <FormattedMessage {...messages.delete} />
      </Button>
    )}
    <Button className="mb-3" block size="large" onClick={onCancel}>
      <FormattedMessage {...messages.cancel} />
    </Button>
    {offerCode && (
      <Button
        className="mb-3"
        block
        size="large"
        href={`/offers/${offerCode}`}
        target="_blank"
      >
        <FormattedMessage {...messages.linkToOffer} />
        <i className="os-icon os-icon-external-link ml-2" />
      </Button>
    )}
  </div>
);

ButtonBoard.defaultProps = {
  canSave: true,
  offerCode: null,
};

ButtonBoard.propTypes = {
  onSave: PropTypes.func.isRequired,
  canSave: PropTypes.bool,
  onCancel: PropTypes.func.isRequired,
  onDelete: PropTypes.func,
  onClone: PropTypes.func,
  offerCode: PropTypes.string,
};

export default ButtonBoard;
